import { createApp } from "vue";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import ComponentsPlus from "@cttq/ui-components-plus-pc";
import "@cttq/ui-components-plus-pc/lib/tq-theme/default.css";
import "@cttq/ui-components-plus-pc/lib/fonts/icons.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import "@/styles/main.css";
import pinia from "@/stores/index";
import * as ElIcon from "@element-plus/icons-vue";

import App from "./App.vue";
import { router } from "./router";
import VuePluginAbility from "@/plugins/vue-plugin-ability";

import privateCapabilities from "@cttq/private-capabilities-v3";

import { useUserCompanyDeptStore } from "@/stores";

const app = createApp(App);
const icons = Object.keys(ElIcon) as (keyof typeof ElIcon)[];
icons.forEach((key) => {
	app.component(key, (ElIcon as any)[key]);
});

// private调试账号
privateCapabilities.userInit("");

router.beforeEach((to, from, next) => {
	if (!window.hasGetMenus) {
		window.hasGetMenus = true;
		privateCapabilities.routerValidate(to, from, next).then(() => {
			const userCompanyDeptStore = useUserCompanyDeptStore();
			if (!userCompanyDeptStore.companyList.length) {
				userCompanyDeptStore.fetchUserCompanyDept();
			}
		});
	} else {
		next();
	}
});

const globalState = privateCapabilities.userGlobalState();

app.use(ElementPlus, { locale: zhCn })
	.use(ComponentsPlus)
	.use(pinia)
	.use(router)
	.use(VuePluginAbility, globalState.state )
	.mount("#app");
